package com.trevorwiebe.timesheet.core.data

import com.trevorwiebe.timesheet.core.domain.TSResult
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.firestore.FirebaseFirestoreException
import kotlinx.coroutines.CancellationException
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.catch
import kotlinx.coroutines.joinAll

object FirestoreListenerRegistry {
    private val activeJobs = mutableListOf<Job>()

    fun registerFlow(flow: Flow<TSResult>): Flow<TSResult> = flow.catch { throwable ->
        if (throwable is CancellationException) throw throwable
        val signedOut = Firebase.auth.currentUser == null
        val expectedOnSignOut = throwable is FirebaseFirestoreException && signedOut
        if (!expectedOnSignOut) {
            emit(TSResult(error = throwable.message ?: "Firestore listener error"))
        }
    }

    fun registerJob(job: Job) {
        activeJobs.add(job)
        job.invokeOnCompletion { activeJobs.remove(job) }
    }

    suspend fun clearAllListeners() {
        val jobs = activeJobs.toList()
        jobs.forEach { it.cancel() }
        jobs.joinAll()
    }
}
